import { render } from "./CompraEditarView.vue?vue&type=template&id=a102927a&ts=true"
import script from "./CompraEditarView.vue?vue&type=script&lang=ts"
export * from "./CompraEditarView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/frontend-marketbo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__